import { render, staticRenderFns } from "./ContestRecent.vue?vue&type=template&id=522d24ed&scoped=true"
import script from "./ContestRecent.vue?vue&type=script&lang=js"
export * from "./ContestRecent.vue?vue&type=script&lang=js"
import style0 from "./ContestRecent.vue?vue&type=style&index=0&id=522d24ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d24ed",
  null
  
)

export default component.exports